import React, { Component } from 'react';

import Amplify, { API, Storage, Analytics } from 'aws-amplify';
import axios from 'axios';

import {
    Container,
    Divider,
    Grid,
    Header,
    Icon,
    Item,
    Message,
    Segment } from "semantic-ui-react";

import ArgoHeader from './components/ArgoHeader';
import Fees from './components/Fees';
import ProjectGallery from './components/ProjectGallery';
import ConstructionParameters from './components/ConstructionParameters';
import ContactDetails from './components/ContactDetails';

import './App.css';

// Load the list of countries (code -> name) that are displayed in the countries drop-down
import _countries from 'react-flags-select/es/countries';

// Production uses environment variables
if (process.env.REACT_APP_API_ENDPOINT) {
    Amplify.configure({
        API: {
            endpoints: [
                {
                    name: "countrycost",
                    endpoint: process.env.REACT_APP_API_ENDPOINT,
                    region: process.env.REACT_APP_REGION                    
                }
            ]
        },
        Auth: {
            // REQUIRED - Amazon Cognito Identity Pool ID
            identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
            // REQUIRED - Amazon Cognito Region
            region: process.env.REACT_APP_REGION,
            // OPTIONAL - Amazon Cognito User Pool ID
            userPoolId: process.env.REACT_APP_USER_POOL_ID,
            // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
            userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEBCLIENT_ID
        },
        Storage: {
            AWSS3: {
                bucket: process.env.REACT_APP_S3_BUCKET,
                region: process.env.REACT_APP_REGION
            }
        },
        Analytics: {
            // OPTIONAL - disable Analytics if true
            disabled: !('REACT_APP_ANALYTICS_APP_ID' in process.env),
            // OPTIONAL - Allow recording session events. Default is true.
            autoSessionRecord: true,
    
            AWSPinpoint: {
                // OPTIONAL -  Amazon Pinpoint App Client ID
                appId: process.env.REACT_APP_ANALYTICS_APP_ID,
                // OPTIONAL -  Amazon service region
                region: process.env.REACT_APP_REGION
            }
        }
    });
} else {
    let awsconfig = require('./aws-exports');
    process.env.REACT_APP_ANALYTICS_APP_ID = awsconfig.default.aws_mobile_analytics_app_id;
    Amplify.configure(awsconfig.default);
}


export default class App extends Component {

    constructor(props) {
        super(props);

        // Populate the state with initial empty data for rending
        this.state = {
            // The country currently being displayed.
            country: {
                measurement: 'imperial',
                currency: 'USD',
                categories: [ {name: ''}],
            },
            fees: [],
            cost: '',
            selectedCategory: {cost: {from: 0, to: 0}},
            floorArea: 1000,
            loading: true,
            images: [],
            showRequestCallback: false
        };

        this.currencyFormatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        })
    }

    updateCurrencyFormatter = () => {
        this.currencyFormatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: this.state.country.currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
    }

    currencyFormat = (estimate) => {
        if (estimate instanceof Array) {
            return this.currencyFormatter.format(estimate[0]) + ' - ' + this.currencyFormatter.format(estimate[1])
        } else {
            return this.currencyFormatter.format(estimate)
        }
    }

    showRequestCallback = () => this.setState({ showRequestCallback: true })
    hideRequestCallback = () => this.setState({ showRequestCallback: false })

    loadCountry = async (countryCode) => {
        try {
            this.setState({ loading: true });
            let responseCountry = await API.get('countrycost', '/countries/object/' + countryCode);
            console.debug('loaded country', responseCountry);
            // Defaults if properties missing
            responseCountry.measurement = responseCountry.measurement || 'imperial';
            responseCountry.currency = responseCountry.currency || 'usd';
            
            // Update the state to with the current country, set the build category to the country's
            // first one.
            this.setState({
                    country: responseCountry,
                    selectedCategory: responseCountry.categories[0]
                },
                () => {
                    this.calculateEstimate();
                    this.updateCurrencyFormatter();
                }
            );

        } catch(error) {
            console.error('Error getting country ' + countryCode, error);
        } finally {
            this.setState({
                    loading: false
                },
                () => Analytics.record({
                    name: 'countryViewed',
                    attributes: { country: countryCode }
                })
            );
        }
    }

    /** When the construction type is changed 
     * typeData = {name: xxx, cost: { from: 0.0, to: 0.0 }}
    */
    onTypeChange = (typeData) => {
        this.setState({
                selectedCategory: typeData
            },
            () => {
                this.calculateEstimate();
                /*Analytics.record({
                    name: 'constructionTypeChanged',
                    attributes: {
                        country: this.state.country.id,
                        constructionType: this.state.selectedCategory.name,
                        floorArea: this.state.floorArea.toString()
                    }
                });*/
            }
        );
    }

    onFloorAreaChange = (area) => {
        this.setState(
            {floorArea: area},
            () => this.calculateEstimate());
    }

    /** When a professional fee is enabled or disabled */
    onFeeToggled = (feeId) => {
        this.setState(prevState => {
            let foundFee = prevState.fees.find(fee => fee.id === feeId)
            // Fees are enabled by default so if it hasn't got an enabled prop, disable it.
            foundFee.enabled  = (foundFee.enabled !== undefined ? !foundFee.enabled : false);
            return prevState;
        }, () => this.calculateEstimate());
    }

    calculateEstimate = () => {
        // The cost.from - cost.to range per 1 area unit.
        let costRange = this.state.selectedCategory.cost;
        let floorArea = parseInt(this.state.floorArea ? this.state.floorArea : 0);

        // Multiply both the low estimate and the high estimate by the construction area.
        let buildingCosts = [costRange.from, costRange.to].map(x => parseInt(x) * floorArea)

        this.setState((prevState, props) => {

            let totals = [];
            let totalPercent = 0;

            // Use the average building cost to find what fee percentage to apply.
            let buildingCostAvg = (buildingCosts[0] + buildingCosts[1]) / 2;

            // For each fee, find the fee percent to apply then add the following properties to the fee object:
            // cost: array with the low and high fee charges
            // percent: the percentage used to calculate the fee costs.
            let feeRanges = prevState.fees.map(fee => {

                    // Get the fee percent that the average build cost falls into.
                    let feeRange = fee.ranges.find(range => buildingCostAvg <= parseInt(range.limit));

                    // If the average cost is higher then the highest range limit, use the percentage of
                    // the last range.
                    if (feeRange === undefined) {
                        console.debug("Cost is higher than largest fee range for " + fee.name);
                        feeRange = fee.ranges[fee.ranges.length - 1];
                    }

                    let percent = parseFloat(feeRange.percent);
                    
                    console.debug(fee.name + ": Using fee percent " + percent + " for cost " + buildingCostAvg);

                    // Calculate the low and high amount for this fee.
                    let costs = buildingCosts.map(x => x * (percent / 100));
                    if (fee.enabled === undefined || fee.enabled === true) {
                        totals.push(costs);
                        totalPercent += percent;
                    }

                    // Update the state with the calculated low and high fee costs, and the percentage used.
                    return Object.assign(fee, {cost: this.currencyFormat(costs), percent: percent});
                });

            // 

            // Add up all the low cost and low fees, and all the high cost and high fees
            // into a low and high total.
            let totalRange = totals.reduce((acc, val) => {
                    return [acc[0] + val[0], acc[1] + val[1]]
                }, [0,0]);

            return {
                cost: this.currencyFormat(buildingCosts),
                fees: feeRanges,
                totalFeesPercent: totalPercent.toFixed(2),
                totalFees: this.currencyFormat(totalRange),
                total: this.currencyFormat([totalRange[0] + buildingCosts[0], totalRange[1] + buildingCosts[1]])
            };
        });
    }

    /** Download the list of country codes that have build costs */
    loadCountryCodes = () => {
        return API.get('countrycost', '/countries').then(response => {
            // Sort the codes using their country name so they are displayed in the correct
            // order in the drop-down list.
            let sortedIds = response.countries.sort((countryCodeA, countryCodeB) => {
                let nameA = _countries[countryCodeA];
                let nameB = _countries[countryCodeB];                
                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }              
                return 0;
            });
            return sortedIds;            
        });
    }

    /** Download all the fee ranges used by all countries */
    loadFees = () => {
        return API.get('countrycost', '/fees')
            .then(response => {
                response.fees.forEach(fee => {
                    fee.ranges.sort((a, b) => parseInt(a.limit) - parseInt(b.limit));
                });
                return response.fees;
            }).catch(error => console.error('Error getting fees', error));
    }

    /** Get the list of image details stored in the S3 bucket. */
    loadPhotoGalleryImages = () => {
        return Storage.list('displayed-in-app/').then(items => {
            let actions = items.map(item => Storage.get(item.key));

            Promise.all(actions).then(urls => {
                this.setState(prevState => {
                    urls.forEach(url => prevState.images.push({ original: url, thumbnail: url, sizes: '300px' }))
                    return prevState;
                });
            });
        }).catch(err => console.error('Could not get photo images', err));
    }

    /**
     * Try to get information about the user's location based on IP.
     */
    loadLocationInfo = () => {
        return axios.get('https://ipapi.co/json/', {timeout: 2500})
            .then(response => {
                let locData = response.data;
                if (locData === "") {
                    console.debug('Could not obtain location');
                    return {};
                } else {            
                    return ({
                        ip: locData.ip,
                        city: locData.city,
                        region: locData.region,
                        countryCode: locData.country,
                        countryName: locData.country_name,
                        postal: locData.postal,
                        latitude: locData.latitude.toFixed(1),
                        longitude: locData.longitude.toFixed(1),
                    });
                }             
            }).catch(err => {
                console.debug('Error getting location data', err);
                return {};
            });
    }

    /**
     * If a user enters their contact details for a callback call the 'notify' endpoint to have
     * an email sent to ARGO. Send the users location and contact details, and the current estimate
     */
    sendContactRequest = (contactDetails) => {
        var selectedFees = this.state.fees
            .filter(fee => (fee.enabled === undefined || fee.enabled === true))
            .map(fee => ({'name': fee.name, 'cost': fee.cost, 'percent': fee.percent}));

        API.post('countrycost', '/notify', {
            body: {
                appId: process.env.REACT_APP_ANALYTICS_APP_ID,
                user: Object.assign(this.state.user, contactDetails),
                country: `${_countries[this.state.country.id]} (${this.state.country.id})`,
                category: this.state.selectedCategory.name,
                floorArea: `${this.state.floorArea.toString()} ${this.state.country.measurement === 'imperial' ? "sq. feet" : "sq. meters"}`,
                buildCost: this.state.cost,
                fees: selectedFees,
                totalFeesPercent: this.state.totalFeesPercent,
                totalFees: this.state.totalFees,
                total: this.state.total
            }
        });
    }

    componentDidMount() {
        Promise.all([
            this.loadFees(),            // Load all the profession fee data
            this.loadCountryCodes(),    // Load the list of countries that have costs available
            this.loadLocationInfo()])   // Load location info based on the ip
        .then((values) => {
            console.debug("Fees retrieved", values[0]);
            console.debug("Country codes ", values[1]);
            this.setState({
                    fees: values[0],
                    countries: values[1],
                    user: values[2],
                },
                () => {
                    // If the user's location could be obtained update the location used in
                    // each analytics event.
                    if (this.state.user.ip !== undefined) {
                        Analytics.updateEndpoint({
                            address: this.state.user.ip,
                            location: {
                                city: this.state.user.city,
                                country: this.state.user.countryCode,
                                latitude: this.state.user.latitude,
                                longitude: this.state.user.longitude,
                                postalCode: this.state.user.postal,
                                region: this.state.user.region
                            }
                        });
                    }
                    // If the user's country was identified use it, otherwise use the first country in the list.
                    let initialCountry = this.state.countries.includes(this.state.user.countryCode) ?
                        this.state.user.countryCode :
                        this.state.countries[0];
                    this.loadCountry(initialCountry);
                }
            );            
        });
        this.loadPhotoGalleryImages()
    }


    render() {
        return (
            <Container>
                <ArgoHeader />
                <ConstructionParameters 
                    country={this.state.country}
                    countryCodes={this.state.countries}
                    loading={this.state.loading}
                    onCountryChange={this.loadCountry}
                    onFloorAreaChange={this.onFloorAreaChange}
                    onTypeChange={this.onTypeChange} />
                <Grid columns={'equal'} divided stackable>
                <Grid.Row>
                <Grid.Column width={11}>
                <Segment color='blue' raised={true} loading={this.state.loading} >
                    <Header dividing={true}>
                        <Icon name='newspaper outline' size='small'/>
                        <Header.Content>
                            Cost Estimate
                            <Header.Subheader>
                                All monetary values are in {this.state.country.currency === 'usd' ? 'US dollars' : 'Euro'}.
                            </Header.Subheader>
                        </Header.Content>
                    </Header>
                    <Item.Group>
                    <Item >
                        <Item.Content>
                            <Item.Header>Indicative Building Costs</Item.Header>
                            <Item.Meta content={`Based on ARGO’s experience working in 
                                    ${this.state.country.id === 'IE' ? "Ireland" : "the Caribbean"},
                                    rates are per square
                                    ${this.state.country.measurement === 'imperial' ? "foot" : "meter"} and adjusted annually.`} />
                            <Item.Description>
                                <Grid columns={1}>
                                    <Grid.Row>
                                        <Grid.Column verticalAlign='bottom'>{`From ${this.currencyFormat(this.state.selectedCategory.cost.from)} to 
                                            ${this.currencyFormat(this.state.selectedCategory.cost.to)} per square 
                                            ${this.state.country.measurement === 'imperial' ? "foot" : "meter"}:`}
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column textAlign='right'>
                                            <Message>{this.state.cost}</Message>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Item.Description>
                        </Item.Content>
                    </Item>
                    </Item.Group>
                    <Item.Group>
                    <Item>
                        <Item.Content>
                            <Item.Header>Indicative Professional Fees</Item.Header>
                            <Item.Meta content='Calculated as a percentage of Indicative Building Costs. These percentages
                                    are guidelines based on project cost and may vary depending on project demands and
                                    complexity. All of the listed professional services below may not be required for your
                                    project. You may deselect as required.' />
                            <Item.Description>
                                <Fees fees={this.state.fees} onFeeToggled={this.onFeeToggled} />
                                <Grid columns={1}>
                                    <Grid.Row>
                                        <Grid.Column>
                                            Total fees at {this.state.totalFeesPercent}%:
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column textAlign='right'><Message>{this.state.totalFees}</Message></Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Item.Description>
                        </Item.Content>
                    </Item>
                    </Item.Group>
                    <Item.Group>
                    <Item>
                        <Item.Content>
                            <Item.Header>Total Cost Estimation</Item.Header>
                            <Item.Meta content='Indicative Building Costs plus Professional Fees.' />
                            <Item.Description>
                                <Grid textAlign='right' columns={1}>
                                    <Grid.Row><Grid.Column><Message>{this.state.total}</Message></Grid.Column></Grid.Row>
                                </Grid>
                                We hope you found the cost calculator to be a useful tool. If you would like to receive a
                                summary of the estimate above and discuss your project further please click 'Request callback'
                                and provide your contact details. A member of our professional team will be more than happy to
                                give you a free consultation and help guide you along the path to successful project completion.
                                 
                            </Item.Description>
                            <Item.Extra> 
                                <ContactDetails triggerLabel='Request callback' onClose={this.sendContactRequest}/>                                                         
                            </Item.Extra>
                        </Item.Content>
                    </Item>
                    </Item.Group>

            </Segment>
            </Grid.Column>
            <Grid.Column stretched>
                <ProjectGallery images={this.state.images} />
            </Grid.Column>
            </Grid.Row>
            </Grid>
            <Divider hidden />
            </Container>

        );
    }

}
